import config from '../../config/config';

import getRequest from './base/get';
import patchRequest from './base/patch';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Dynamic pricing list based on filters
   * @param {any} query query
   * @returns {any} promise
   */
  fetchDynamicPricing: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/dynamic-pricing/`, {
      ...parameters,
    });
  },
  /**
   * Function to fetch list of filter for dynamic pricing
   * @returns {any} A promise resolving to the list of dynamic pricing filters
   */
  fetchDynamicPricingFilterList: () =>
    getRequest(`${config.commonApiUrl}api/super-admin/v1/dynamic-pricing/list-filters`),
  /**
   * Fetch the Dynamic pricing list for export
   * @param {any} query query
   * @returns {any} promise
   */
  fetchDynamicPricingExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/dynamic-pricing/export-data`, {
      ...parameters,
    });
  },

  /**
   * Update the status of dynamic pricing
   * @param {any} id - The dynamic pricing ID
   * @param {any} data - The update data
   * @returns {any} A promise that resolves with the update response
   */
  updateDynamicPricing: (id: string, data: any): Promise<any> => {
    return patchRequest(`${config.commonApiUrl}api/super-admin/v1/dynamic-pricing/${id}`, data);
  },

  /**
   * Fetch the Dynamic pricing pending notification count
   * @returns {any} promise
   */
  fetchPendingNotificationCount: (): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/super-admin/v1/dynamic-pricing/pending-count`);
  },
};
